import React from "react";
import {
	CardHeader,
	Typography,
	Avatar,
	Skeleton,
} from "@mui/material";

import Icon from "../icon/icon";

import css from "./hero-metrics.module.css";
import { currencyFormatted } from "../../util";

const HeroMetrics = (props) => {
	const { invoices, invoiceLoading } = props;

	//   useEffect(() => {
	// console.log(invoices)
	// setTriggerTransition(!triggerTransition)
	// }, [invoices]);

	const approvedInv = invoices?.filter((inv) => inv?.status === "APPROVED");
	const paidInv = invoices?.filter((inv) => inv?.status === "PAID");

	const getInvoiceTotal = (invoices) => {
		const amt = invoices
			?.map((inv) =>
				inv?.invoice_items?.reduce(function (acc, item) {
					return acc + item?.quantity * item?.retail_price;
				}, 0)
			)
			.reduce(function (acc, amt) {
				return acc + amt;
			}, 0);

		return amt;
	};

	const getEligibleRebateTotal = (invoices) => {
		const amt = invoices
			?.map((inv) =>
				inv?.invoice_items?.reduce(function (acc, item) {
					return (
						acc +
						(item?.eligibility === "ELIGIBLE"
							? item.quantity *
							  (item.retail_price * inv.rebate_amt)
							: 0)
					);
				}, 0)
			)
			.reduce(function (acc, amt) {
				return acc + amt;
			}, 0);
		return amt;
	};

	const getEligibleTotal = (invoices) => {
		const amt = invoices
			?.map((inv) =>
				inv?.invoice_items?.reduce(function (acc, item) {
					return (
						acc +
						(item?.eligibility === "ELIGIBLE"
							? item.quantity * item.retail_price
							: 0)
					);
				}, 0)
			)
			.reduce(function (acc, amt) {
				return acc + amt;
			}, 0);
		return amt;
	};

	const getInvoiceTotalItems = (invoices) => {
		const qty = invoices
			?.map((inv) =>
				inv?.invoice_items?.reduce(function (acc, item) {
					return acc + item.quantity;
				}, 0)
			)
			.reduce(function (acc, amt) {
				return acc + amt;
			}, 0);
		return qty;
	};

	const submitted = {
		value: invoices?.length || 0,
		name: "Submitted",
		icon: <Icon icon="Receipt" />,
		totaAmtName: "Invoice Total",
		totalAmt: getInvoiceTotal(invoices),
		qtyItemsName: "Total Items",
		qtyItems: getInvoiceTotalItems(invoices),
	};
	const approved = {
		value: approvedInv?.length || 0,
		name: "Approved",
		totaAmtName: "Eligible Total",
		totalAmt: getEligibleTotal(approvedInv),
		icon: <Icon icon="ReceiptCheck" />,
		qtyItemsName: "Rebate Total",
		qtyItems: `$${getEligibleRebateTotal(approvedInv)}`,
	};
	const paid = {
		value: paidInv?.length || 0,
		name: "Paid",
		totaAmtName: "Eligible Total",
		totalAmt: getEligibleTotal(paidInv),
		qtyItemsName: "Rebate Total",
		qtyItems: `$${getEligibleRebateTotal(paidInv)}`,
		icon: <Icon icon="CurrencyDollarCircle" />,
	};

	const metrics = [submitted, approved, paid];

	return (
		<div className={css.metricsBlock}>
			{metrics?.map((m, i) => {
				return (
					<div key={m.name} className={css.card}>
						<div className={css.row}>
							<Typography
								gutterBottom
								variant="h5"
								component="div"
							>
								<CardHeader
									titleTypographyProps={{
										fontWeight: "bold",
										variant: "h4",
									}}
									title={`${m?.name} Invoices `}
									avatar={
										<Avatar
											sx={{ bgcolor: "#02518D" }}
											aria-label="recipe"
										>
											{m.icon}
										</Avatar>
									}
								></CardHeader>
							</Typography>

							{invoiceLoading ? (
								<Skeleton variant="rounded" width={48} height={34} sx={{ borderRadius: "6px" }} />
							) : (
								<Typography
									gutterBottom
									style={{ fontWeight: "bolder" }}
									variant="h4"
									component="div"
								>
									{m?.value}
								</Typography>
							)}
						</div>

						<div className={css.row}>
							<div className={css.stack}>
								<p>{m?.totaAmtName}</p>
								{invoiceLoading ? (
									<Skeleton variant="rounded" width={80} height={20} sx={{ borderRadius: "6px" }} />
								) : (
									<p className={css.val}>
										{currencyFormatted(m?.totalAmt)}
									</p>
								)}
							</div>

							<div className={css.stack}>
								<p>{m?.qtyItemsName}</p>
								{invoiceLoading ? (
									<Skeleton variant="rounded" width={80} height={20} sx={{ borderRadius: "6px" }} />
								) : (
									<>
										{m?.name === "Submitted" && m?.qtyItems ? (
											<p className={css.val}>{m?.qtyItems.toLocaleString('en-US')}</p>
										) : (
											<p className={css.val}>{currencyFormatted(m?.qtyItems)}</p>
										)}
									</>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};
export default HeroMetrics;
